import type { CalendarEvent } from 'owa-calendar-types';
import { action } from 'satcheljs';
import type { InsightsDataFetchSource } from 'owa-meeting-insights-types-and-flights';

export const initializeEventRelatedContent = action('initializeEventRelatedContent');

export const prefetchInsights = action(
    'prefetchInsights',
    (events: CalendarEvent[], dataFetchSource: InsightsDataFetchSource) => ({
        events,
        dataFetchSource,
    })
);
